import { h, render, Component } from 'preact';
import CommonBlock from './commonBlock';
import { insertCustomComponents } from './common';
import Utils from '../../utils';
import { Context } from '../context';
import CiblerAPI from '../ciblerApi';

export default class PopupMail extends CommonBlock {
  constructor(props) {
    super(props);

    const content = this.renderSimpleContent(props);

    this.state = {
      content,
      mail: '',
      optin: false,
    };
  }

  getStyle = () => {
    const style = { padding: '10px' };
    if (Utils.getCampaignData(this.props.backgroundImg)) style.backgroundImage = `url('${Context.clientUrl}campaigns/assets/${this.props.campaignId}/${Context.device}${Utils.getCampaignData(this.props.backgroundImg)}')`;
    if (Utils.getCampaignData(this.props.height)) style.maxHeight = Utils.getCampaignData(this.props.height);
    if (Utils.getCampaignData(this.props.textColor)) style.color = Utils.getCampaignData(this.props.textColor);
    if (Utils.getCampaignData(this.props.exitUrl)) style.cursor = 'pointer';
    const styleKey = ['backgroundColor', 'fontFamily', 'width', 'top', 'left', 'bottom', 'right'];
    styleKey.forEach((key) => {
      if (Utils.getCampaignData(this.props[key])) style[key] = Utils.getCampaignData(this.props[key]);
    });

    return style;
  };

  getExitStyle = () => {
    const exitStyle = {
      background: 'none', border: 'none', top: '0', right: '0', position: 'absolute', margin: '5px',
    };
    if (Utils.getCampaignData(this.props.exitButtonColor)) exitStyle.background = this.props.exitButtonColor.value;
    if (Utils.getCampaignData(this.props.exitButtonFontColor)) exitStyle.color = this.props.exitButtonFontColor.value;
    if (Utils.getCampaignData(this.props.fontFamily)) exitStyle.fontFamily = this.props.fontFamily.value;
    if (Utils.getCampaignData(this.props.exitButtonTop)) exitStyle.top = this.props.exitButtonTop.value;
    if (Utils.getCampaignData(this.props.exitButtonRight)) exitStyle.right = this.props.exitButtonRight.value;

    return exitStyle;
  };

  getOptin = () => {
    if (!Utils.getCampaignData(this.props.optinlabel, '')) return null;
    return (
      <div>
        <input
          id="WioOptin"
          name="WioOptin"
          type="checkbox"
          checked={this.state.optin}
          onChange={e => this.setState({ optin: e.target.checked })}
        />
        <label htmlFor="WioOptin">{Utils.getCampaignData(this.props.optinlabel, '')}</label>
      </div>);
  };

  getMailBlock = () => (<input
    id="wioBlockMail"
    style={{
      bottom: 'calc(10% + 50px)', left: '30%', position: 'absolute', width: '40%',
    }}
    onChange={e => this.setState({ mail: e.target.value })}
    value={this.state.mail}
  />);

  handleClick = (e) => {
    e.stopPropagation();

    CiblerAPI.sendPriceToMail(this.state);

    return false;
  };

  render() {
    const banClass = Utils.getCampaignData(this.props.emplacement) ? `Wio${Utils.getCampaignData(this.props.emplacement)}` : '';
    const modalStyle = {};
    if (Utils.getCampaignData(this.props.modalColor, '')) modalStyle.backgroundColor = Utils.getCampaignData(this.props.modalColor, '');

    return (
      <div>
        <div
          id="wio_mail"
          style={this.getStyle()}
          className={`WioFloat ${banClass} WioPopupMail`}
        >
          <div
            id="wioContent"
            dangerouslySetInnerHTML={{ __html: this.state.content }}
          />
          {this.getMailBlock()}
          {this.getOptin()}
          {this.insertAcceptButton()}
          <button
            id="wioBlockExit"
            style={this.getExitStyle()}
            onClick={this.closeBlock}
          >
            X
          </button>
        </div>
        <div id="WioModal" className="WioModal" style={modalStyle} onClick={this.closeBlock} />
      </div>
    );
  }
}
